export default __webpack_public_path__ + "static/media/roboto-v20-latin-300italic.aa2a7c0d.eot";